import { Form } from './approval-disapprove-modal-controller';

type IdType = number | string | undefined;

interface DisapprovalResponse {
  approvalId: IdType,
  processId: IdType,
  reasonId: string | number
  observation: string
}

interface FormData extends DisapprovalResponse, Record<string, any> {}

const normalizeDisapproveBody = (formData: Form, approvalId: IdType, processId: IdType): FormData => ({
  approvalId: approvalId,
  processId: processId,
  reasonId: formData.reason.id,
  observation: formData.observation,
});

export {
  normalizeDisapproveBody,
};
